import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    clubData: { Logo: '' },
    accessToken: ""
  },
  getters: {
    GET_CLUB_DATA (state) {
      return state.clubData
    }
  },
  mutations: {
    UPDATE_CLUB_DATA (state, payload) {
      state.clubData = payload
    }
  }
})